import {autoRegister, resolve} from "../../container";
import {PageFeatures} from "./pageFeatures";
import {elementFrom} from "../../common/utils/html";

@autoRegister()
export class Backdrop {
    private backdrop: HTMLElement;

    public constructor(
        pageFeatures: PageFeatures = resolve(PageFeatures)
    ) {
        this.backdrop = pageFeatures.insert<HTMLElement>(elementFrom(`<div class="backdrop"></div>`));
    }

    public show(): void {
        this.backdrop.classList.add("visible");
    }

    public hide(): void {
        this.backdrop.classList.remove("visible");
    }
}